import React, { useEffect, useState } from "react";

// Antd
import { Button, Steps, Modal, Form, Space, Spin } from "antd";

// Constant

// Style
import "./style.scss";

// Component
import File from "./File";
import Roles from "./Roles";
import Detail from "./Detail";
import Loading from "components/Loading";

// Redux
import { useDispatch, useSelector } from "react-redux";
import Compliance from "./Compliance";

// Localization
import LOCALIZATION from "services/LocalizationService";

// Helper
import { errorNotification } from "helpers/Notification";

// Data parser
import { getUserInfo, parseGeneralErrorMessage } from "helpers/GeneralHelper";

// Date Fns
import { format } from "date-fns";

// Constants
import { API_URLS } from "../../../../src/constants/ApiUrl";
import { REDUX_STATES } from "constants/ReduxStates";
import { DATE_FORMAT } from "constants/DateFormat";
import STATUS_CODES from "constants/StatusCodes";

// Actions
import {
  patchAction,
  postAction,
  getAction,
  triggerProjectLoad,
  deleteAction,
  resetCustomStateData,
} from "store/actions/CRUDAction";
import { ADD_PROJECT_KEYS } from "./Constant";
import { parseEditUserData } from "dataParser/Project";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Link } from "react-router-dom";
import { CheckIcon } from "./images";
import FileUploading from "./FileUploading";

const {
  FILE_UPLOAD,
  PROJECT_DETAIL,
  LOADING,
  USERS,
  RESPONSE,
  ROLES,
  UPDATE_COMPLIANCE,
  COMPLIANCE,
} = REDUX_STATES;

let projectIdCopy = 0;
let loadingModalCopy = false;
var maxStep = 0;
var stepHistory = {};

const Index = ({ setProjectModal }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  // const navigate = useNavigate();
  const [current, setCurrent] = useState(0);
  const [loadingModal, setLoadingModal] = useState(false);
  const [isProjectCompleted, setIsProjectCompleted] = useState(false);
  const [statusCreated, setStatusCreated] = useState(false);
  const [formData, setFormData] = useState({}); // State to store form data
  const [excelFile, setExcelFile] = useState([]);
  const [projectId, setProjectId] = useState("");
  const [ComplianceObject, setComplianceObject] = useState([]);
  const [ComplianceData, setComplianceData] = useState([]);
  const [headerCheckedStates, setHeaderCheckedStates] = useState({});
  const [childCheckedStates, setChildCheckedStates] = useState([]);
  const [form] = Form.useForm();

  const [fileUploading, setFileUploading] = useState(false);
  const [progress, onUploadProgress] = useState("");
  const [uploadFailed, setFailed] = useState("");

  const [defaultActiveComp, setDefaultActiveComp] = useState("");
  const [defaultActiveCompIdx, setDefaultActiveCompIdx] = useState("");
  const [unCheckedCompliance, setUnCheckedCompliance] = useState("");
  const userInfo = getUserInfo();


  const {
    [FILE_UPLOAD + LOADING]: loading = false,
    [FILE_UPLOAD + RESPONSE]: fileData = {},
    [COMPLIANCE + LOADING]: loadingCompliance = false,
    [USERS + LOADING]: loadingUsers = false,
    [USERS + RESPONSE]: allUser = {},
  } = useSelector((state) => state.Crud);

  const getAllUsers = () => {
    console.log('=== STEP 2: Fetching All Users ===');
    
    try {
      dispatch(getAction(API_URLS.USERS, {}, USERS)).then(
        (response) => {
          console.log('=== STEP 2: Users Fetched SUCCESS ===');
          console.log('Number of users:', response?.success?.data?.length || response?.length || 0);
        },
        (error) => {
          console.error('=== STEP 2: Users Fetch FAILED ===');
          console.error('Error details:', error);
        }
      ).catch((error) => {
        console.error('=== STEP 2: Unexpected Error in getAllUsers ===');
        console.error('Catch block error:', error);
      });
    } catch (error) {
      console.error('=== STEP 2: Exception in getAllUsers ===');
      console.error('Exception details:', error);
    }
  };

  const ComplianceApi = (id) => {
    console.log('=== STEP 3: Fetching Compliance Data ===');
    console.log('Project ID for compliance:', id);
    
    if (!id) {
      console.error('=== STEP 3: ERROR - No project ID provided ===');
      return;
    }
    
    try {
      dispatch(getAction(API_URLS.COMPLIANCE + id, {}, COMPLIANCE)).then(
        (e) => {
          console.log('=== STEP 3: Compliance Data Fetched SUCCESS ===');
          console.log('Compliance response:', e);
          console.log('Number of compliance items:', e?.success?.data?.length || 0);
          
          setComplianceData(e);
          setUnCheckedCompliance(e?.success?.data);
        },
        (e) => {
          console.error('=== STEP 3: Compliance Data Fetch FAILED ===');
          console.error('Error details:', {
            message: e?.message,
            status: e?.response?.status,
            statusText: e?.response?.statusText,
            data: e?.response?.data,
            detail: e?.response?.data?.detail
          });
          
          const errMsg = parseGeneralErrorMessage(
            e.response?.data || e.response?.data?.detail
          );
          const message =
            e?.response?.status === STATUS_CODES.BAD_REQUEST ||
              STATUS_CODES.FORBIDDEN
              ? errMsg || LOCALIZATION.API_ERROR
              : LOCALIZATION.INTERNAL_SERVER_ERROR_MESSAGE;

          errorNotification(message);
        }
      ).catch((error) => {
        console.error('=== STEP 3: Unexpected Error in ComplianceApi ===');
        console.error('Catch block error:', error);
        errorNotification('An unexpected error occurred while fetching compliance data');
      });
    } catch (error) {
      console.error('=== STEP 3: Exception in ComplianceApi ===');
      console.error('Exception details:', error);
      errorNotification('Failed to initiate compliance data fetch');
    }
  };

  const next = () => {
    form
      .validateFields()
      .then(() => {
        const currentFormData = form.getFieldsValue();
        setFormData((prevFormData) => ({
          ...prevFormData,
          ...currentFormData,
        }));
        setCurrent(current + 1);
        maxStep = current + 1;
        if (stepHistory[0]) return;
        excelFileUpload();

        stepHistory[current] = true;
      })
      .catch((errorInfo) => {
        stepHistory[current] = false;
      });
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const removeFileData = () => {
    dispatch(resetCustomStateData(FILE_UPLOAD, {}))
  }
  useEffect(() => {
    return (() => {
      setExcelFile([]);
      setFormData({});
      removeFileData();
      setFailed(true);
      form.resetFields();
      handleDeleteUnCompletedProject(projectIdCopy, loadingModalCopy);
      stepHistory[0] = false;
      maxStep = 0;
    })
  }, [])

  const steps = [
    {
      title: LOCALIZATION.CREATE_NEW_PROJECT,
      content: (
        <File
          excelFile={excelFile}
          setExcelFile={setExcelFile}
          confirmOnDelete={!uploadFailed}
          onRemove={() => {
            handleDeleteUnCompletedProject(projectIdCopy, loadingModalCopy);
            setFormData({});
            stepHistory[0] = false;
            maxStep = 0;
          }}
        />
      ),
    },
    {
      title: LOCALIZATION.CONFIRM_DETAIL,
      content: fileUploading ? (
        <FileUploading
          file={excelFile[0]}
          failed={uploadFailed}
          meta={progress}
        />
      ) : (
        <Detail form={form} />
      ),
    },
  ];

  const getFormData = () => {
    var formData = new FormData();
    formData.append(ADD_PROJECT_KEYS.FILE, excelFile[0]?.originFileObj);
    return formData;
  };

  const addProjectRoles = () => {
    console.log('=== STEP 6: Adding Project Roles ===');
    
    try {
      const currentFormData = form.getFieldsValue();
      const groupRoles = currentFormData?.group_roles || [];
      if (!groupRoles.length) {
        handleCheckStatus();
        return;
      }
      const data = groupRoles.map((item) => ({ ...item, id: userInfo?.id }));
      
      console.log('User info:', userInfo);
      console.log('Form data for roles:', currentFormData?.group_roles);
      
      for (let element of data) {
        element["projects"] = projectId;
      }
      
      console.log('Roles data to submit:', data);
      console.log('Number of roles:', data?.length || 0);
      
      dispatch(postAction(`${API_URLS.ROLES}`, data, {}, ROLES)).then(
        (response) => {
          console.log('=== STEP 6: Project Roles Added SUCCESS ===');
          console.log('Response:', response);
          console.log('=== STEP 7: Checking Project Status ===');
          handleCheckStatus();
        },
        (e) => {
          console.error('=== STEP 6: Project Roles Addition FAILED ===');
          console.error('Error details:', {
            message: e?.message,
            status: e?.response?.status,
            statusText: e?.response?.statusText,
            data: e?.response?.data,
            errors: e?.response?.data?.errors
          });
          
          const message = e?.response?.data?.errors[0]?.non_field_errors
            ? e?.response?.data?.errors[0]?.non_field_errors
            : e?.response?.status === STATUS_CODES.NOT_FOUND
              ? LOCALIZATION.ROLES_ADDED_ERROR
              : LOCALIZATION.NETWORK_ERROR;
          
          errorNotification(message);
          setLoadingModal(false);
        }
      ).catch((error) => {
        console.error('=== STEP 6: Unexpected Error in addProjectRoles ===');
        console.error('Catch block error:', error);
        errorNotification('An unexpected error occurred while adding project roles');
        setLoadingModal(false);
      });
    } catch (error) {
      console.error('=== STEP 6: Exception in addProjectRoles ===');
      console.error('Exception details:', error);
      errorNotification('Failed to prepare project roles data');
      setLoadingModal(false);
    }
  };

  const handleCheckStatus = () => {
    console.log('=== STEP 7: Checking Project Status ===');
    console.log('Project ID for status check:', projectId);
    
    try {
      setTimeout(() => {
        console.log('Status check initiated after 2 second delay');
        
        dispatch(
          getAction(`${API_URLS.CHECK_STATUS}${projectId}`, {}, ROLES)
        ).then(
          (response) => {
            console.log('=== STEP 7: Status Check Response Received ===');
            console.log('Response:', response);

            if (response?.success) {
              console.log('=== PROJECT CREATION COMPLETED SUCCESSFULLY ===');
              console.log('Final project ID:', projectId);
              
              maxStep = 0;
              stepHistory[0] = false;
              setExcelFile();
              setComplianceData();
              setHeaderCheckedStates([]);
              setChildCheckedStates([]);
              form.resetFields();
              setCurrent(0);
              dispatch(triggerProjectLoad());
              setStatusCreated(true);
              setIsProjectCompleted(true);
              
              console.log('=== All cleanup and state reset completed ===');
            } else {
              console.warn('=== STEP 7: Status check returned non-success ===');
              console.warn('Response:', response);
              errorNotification('Project status verification failed. Please check the project manually.');
              setLoadingModal(false);
            }
          },
          (e) => {
            console.error('=== STEP 7: Status Check FAILED ===');
            console.error('Error details:', {
              message: e?.message,
              status: e?.response?.status,
              statusText: e?.response?.statusText,
              data: e?.response?.data,
              payload: e?.payload
            });

            errorNotification(e.payload?.message || 'Failed to verify project status');
            setLoadingModal(false);
          }
        ).catch((error) => {
          console.error('=== STEP 7: Unexpected Error in handleCheckStatus ===');
          console.error('Catch block error:', error);
          errorNotification('An unexpected error occurred while checking project status');
          setLoadingModal(false);
        });
      }, 2000);
    } catch (error) {
      console.error('=== STEP 7: Exception in handleCheckStatus ===');
      console.error('Exception details:', error);
      errorNotification('Failed to initiate status check');
      setLoadingModal(false);
    }
  };

  const updateProjectDetail = (id) => {
    console.log('=== STEP 4: Updating Project Details ===');
    
    try {
      const data = {
        [ADD_PROJECT_KEYS.WORK_DIRECTIVE]:
          formData?.[ADD_PROJECT_KEYS.WORK_DIRECTIVE],
        [ADD_PROJECT_KEYS.CLIENT]: formData?.[ADD_PROJECT_KEYS.CLIENT],
        [ADD_PROJECT_KEYS.WORK_ORDER_NUMBER]:
          formData?.[ADD_PROJECT_KEYS.WORK_ORDER_NUMBER],
        [ADD_PROJECT_KEYS.START_DATE]: formData?.[ADD_PROJECT_KEYS.START_DATE],
        [ADD_PROJECT_KEYS.END_DATE]: formData?.[ADD_PROJECT_KEYS.END_DATE],
      };
      
      // Use the id parameter instead of projectId state
      const finalProjectId = id || projectId;
      
      console.log('Project ID:', finalProjectId);
      console.log('Update data:', data);
      
      if (!finalProjectId) {
        console.error('=== STEP 4: ERROR - No project ID available ===');
        errorNotification('Cannot update project: No project ID available');
        setLoadingModal(false);
        return;
      }
      
      dispatch(
        patchAction(`${API_URLS.PROJECT}${finalProjectId}/`, data, {}, PROJECT_DETAIL)
      ).then(
        (response) => {
          console.log('=== STEP 4: Project Details Updated SUCCESS ===');
          console.log('Response:', response);
          console.log('=== STEP 5: Skipping Compliance Update (section hidden) ===');
          addProjectRoles();
        },
        (e) => {
          console.error('=== STEP 4: Project Details Update FAILED ===');
          console.error('Error details:', {
            message: e?.message,
            status: e?.response?.status,
            statusText: e?.response?.statusText,
            data: e?.response?.data,
            errors: e?.response?.data?.errors
          });
          
          const message = e?.response?.data?.errors
            ? e?.response?.data?.errors
            : e?.response?.status === STATUS_CODES.NOT_FOUND
              ? LOCALIZATION.PROJECT_DETAIL_ADDED_ERROR
              : LOCALIZATION.NETWORK_ERROR;
          
          errorNotification(message);
          setLoadingModal(false);
        }
      ).catch((error) => {
        console.error('=== STEP 4: Unexpected Error in updateProjectDetail ===');
        console.error('Catch block error:', error);
        errorNotification('An unexpected error occurred while updating project details');
        setLoadingModal(false);
      });
    } catch (error) {
      console.error('=== STEP 4: Exception in updateProjectDetail ===');
      console.error('Exception details:', error);
      errorNotification('Failed to prepare project update data');
      setLoadingModal(false);
    }
  };

  const patchCompliance = (data, id) => {
    console.log('=== STEP 5: Updating Compliance Data ===');
    
    try {
      const filteredElements = data.filter(
        (item) => item?.notification_trigger === false
      );
      
      // Use passed id or fall back to projectId state
      const finalProjectId = id || projectId;
      
      console.log('Project ID:', finalProjectId);
      console.log('Compliance items to update:', filteredElements?.length || 0);
      console.log('Filtered compliance data:', filteredElements);
      
      if (!finalProjectId) {
        console.error('=== STEP 5: ERROR - No project ID available ===');
        errorNotification('Cannot update compliance: No project ID available');
        setLoadingModal(false);
        return;
      }
      
      dispatch(
        patchAction(
          API_URLS.UPDATE_COMPLIANCE + finalProjectId + "/",
          filteredElements,
          {},
          UPDATE_COMPLIANCE
        )
      ).then(
        (response) => {
          console.log('=== STEP 5: Compliance Updated SUCCESS ===');
          console.log('Response:', response);
          console.log('=== STEP 6: Starting Project Roles Addition ===');
          addProjectRoles();
        },
        (e) => {
          console.error('=== STEP 5: Compliance Update FAILED ===');
          console.error('Error details:', {
            message: e?.message,
            status: e?.response?.status,
            statusText: e?.response?.statusText,
            data: e?.response?.data
          });
          
          const errMsg = parseGeneralErrorMessage(e?.response?.data);
          const message =
            e?.response?.status === STATUS_CODES.BAD_REQUEST
              ? errMsg || LOCALIZATION.UPDATE_ERROR
              : LOCALIZATION.INTERNAL_SERVER_ERROR_MESSAGE;
          
          errorNotification(message);
          setLoadingModal(false);
        }
      ).catch((error) => {
        console.error('=== STEP 5: Unexpected Error in patchCompliance ===');
        console.error('Catch block error:', error);
        errorNotification('An unexpected error occurred while updating compliance');
        setLoadingModal(false);
      });
    } catch (error) {
      console.error('=== STEP 5: Exception in patchCompliance ===');
      console.error('Exception details:', error);
      errorNotification('Failed to prepare compliance update data');
      setLoadingModal(false);
    }
  };

  const onSubmit = () => {
    console.log('=== PROJECT CREATION STARTED ===');
    console.log('Current project ID:', projectId);
    console.log('Form data before processing:', formData);
    
    try {
      setLoadingModal(true);
      
      Object.keys(formData || {})?.map((key) => {
        if (key?.includes("date")) {
          if (formData[key] === "Invalid Date") {
            formData[key] = null;
          }
          formData[key] = !!formData[key]
            ? format(new Date(formData[key]), DATE_FORMAT.YEAR_MONTH_DAY)
            : null;
        }
      });
      
      console.log('Form data after date processing:', formData);
      console.log('=== Starting Project Detail Update ===');

      updateProjectDetail(projectId);
    } catch (error) {
      console.error('=== ERROR in onSubmit ===');
      console.error('Exception details:', error);
      errorNotification('Failed to submit project data. Please try again.');
      setLoadingModal(false);
    }
  };

  const excelFileUpload = () => {
    if (current === 0) {
      console.log('=== STEP 1: Starting Excel File Upload ===');
      console.log('File details:', {
        fileName: excelFile[0]?.name,
        fileSize: excelFile[0]?.size,
        fileType: excelFile[0]?.type
      });
      
      setFailed(false);
      setFileUploading(true);
      
      try {
        dispatch(
          postAction(
            API_URLS.PROJECT,
            getFormData(),
            { 
              onUploadProgress,
              timeout: 300000 // 5 minutes timeout for large files
            },
            FILE_UPLOAD,
            "formdata"
          )
        ).then(
          (response) => {
            console.log('=== STEP 1: File Upload SUCCESS ===');
            console.log('Upload response:', response);
            
            // Handle both response structures: response.payload.project or response.data.payload.project
            const projectId = response?.payload?.project?.id || response?.data?.payload?.project?.id;
            
            if (!projectId) {
              console.error('=== STEP 1: ERROR - No project ID in response ===');
              console.error('Response structure:', JSON.stringify(response, null, 2));
              errorNotification('Project upload failed: No project ID received');
              setFileUploading(false);
              setFailed(true);
              setCurrent(0);
              stepHistory[0] = false;
              return;
            }
            
            console.log('Project ID received:', projectId);
            console.log('=== STEP 2: Fetching Users ===');
            
            getAllUsers();
            
            console.log('=== STEP 3: Fetching Compliance Data ===');
            ComplianceApi(projectId);
            setProjectId(projectId);
            setFileUploading(false);
            
            console.log('=== File Upload Process Completed Successfully ===');
          },
          (e) => {
            console.error('=== STEP 1: File Upload FAILED ===');
            console.error('Error details:', {
              message: e?.message,
              status: e?.response?.status,
              statusText: e?.response?.statusText,
              data: e?.response?.data,
              code: e?.code,
              isAxiosError: e?.isAxiosError,
              config: {
                url: e?.config?.url,
                method: e?.config?.method,
                timeout: e?.config?.timeout
              }
            });
            
            let errorMessage = 'File upload failed. ';
            
            // Handle different error types
            if (e?.code === 'ECONNABORTED' || e?.message?.includes('timeout')) {
              errorMessage += 'Request timed out. The file might be too large or the server is taking too long to respond. Please try again with a smaller file or contact support.';
              console.error('TIMEOUT ERROR: Upload exceeded time limit');
            } else if (e?.code === 'ERR_NETWORK' || !e?.response) {
              errorMessage += 'Network error. Please check your internet connection and try again.';
              console.error('NETWORK ERROR: No response from server');
            } else if (e?.response?.status === 413) {
              errorMessage += 'File is too large. Please reduce the file size and try again.';
              console.error('FILE SIZE ERROR: File exceeds server limit');
            } else if (e?.response?.status >= 500) {
              errorMessage += 'Server error. Please try again later or contact support.';
              console.error('SERVER ERROR: Internal server error');
            } else {
              errorMessage = e?.response?.data?.errors || e?.response?.data?.error || e?.message || errorMessage;
            }
            
            setCurrent(0);
            stepHistory[0] = false;
            errorNotification(errorMessage);
            setFileUploading(false);
            setFailed(true);
            
            console.error('=== Upload Process Terminated ===');
          }
        ).catch((error) => {
          console.error('=== STEP 1: Unexpected Error in Upload Promise ===');
          console.error('Catch block error:', error);
          setCurrent(0);
          stepHistory[0] = false;
          errorNotification('An unexpected error occurred during file upload. Please try again.');
          setFileUploading(false);
          setFailed(true);
        });
      } catch (error) {
        console.error('=== STEP 1: Exception in excelFileUpload ===');
        console.error('Exception details:', error);
        setCurrent(0);
        stepHistory[0] = false;
        errorNotification('Failed to initiate file upload. Please check your file and try again.');
        setFileUploading(false);
        setFailed(true);
      }
    }
  };

  const items = steps.map((item) => ({ key: item.title, title: item.title }));

  const createAnotherProject = () => {
    window.location.reload();
    setExcelFile();
    setComplianceData();
    setHeaderCheckedStates([]);
    setChildCheckedStates([]);
    form.resetFields();
    setCurrent(0);
    dispatch(triggerProjectLoad());
    setLoadingModal(false);
    setProjectId(null);
  };
  const handleOpenProject = () => {
    setProjectId(null);
    setExcelFile();
    setComplianceData();
    setHeaderCheckedStates([]);
    setChildCheckedStates([]);
    form.resetFields();
    setCurrent(0);
    dispatch(triggerProjectLoad());
    setLoadingModal(false);
  };

  const LoadingModalFooter = () => {
    return (
      <div className="loadingFooter">
        <button id="createNewButton" onClick={createAnotherProject}>
          Create another project
        </button>

        <Link to={`/projects${projectId}/detail/${projectId}`}>
          <button id="openButton" type="auth" onClick={handleOpenProject}>
            Open project
          </button>
        </Link>
      </div>
    );
  };

  const handleModalCancel = () => {
    window.location.reload();
    setProjectId(null);
    setLoadingModal(false);
  };

  const handleDeleteUnCompletedProject = (id, ismodalOpen) => {
    if (id === null || id === 0 || id == "" || id === undefined || ismodalOpen === true)
      return;

    dispatch(deleteAction(API_URLS.DELETE_UNCOMPLETE_PROJECT + id)).then(
      (response) => {
        setProjectId(null);
      },
      (e) => {
        setCurrent(0);
        errorNotification(e?.response?.data?.errors || "Something went wrong!");
      }
    );
  };

  useEffect(() => {
    projectIdCopy = projectId;
    loadingModalCopy = loadingModal;
  }, [projectId, loadingModal]);

  useEffect(() => {
    return () => {
      handleDeleteUnCompletedProject(projectIdCopy, loadingModalCopy);
    };
  }, []);

  useEffect(() => {
    if (form) {
      const currentFormData = form.getFieldsValue();
      form.setFieldsValue({ ...currentFormData, ...formData });
    }
    
  }, [current, formData]);

  const isNextDisabled = (current) => {
    if (fileUploading) return true;

    switch (current) {
      case 0:
        return !excelFile?.length;
      case 1:
      case 2:
      case 4:
        return false;
    }
  };

  return (
    <>
      {!fileUploading && (loading || loadingUsers || loadingCompliance) && (
        <Loading />
      )}
      <div className="project-wrapper">
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          fields={parseEditUserData(fileData, ADD_PROJECT_KEYS)}
          className="project-form"
        >
          <Steps
            current={current}
            items={items}
            onChange={(num) => {
              if (num <= maxStep) setCurrent(num);
            }}
          />

          <div className="content-wrapper">{steps[current].content}</div>

          <div className="toggle-buttons">
            <div>
              {current === 0 && null}
              {current > 0 && (
                <Button
                  type="light"
                  onClick={() => prev()}
                  disabled={current === 0 ? true : false}
                >
                  {LOCALIZATION.BACK}
                </Button>
              )}
            </div>
            <div>
              {current === steps.length - 1 && (
                <Button type="auth" htmlType="submit">
                  {LOCALIZATION.CREATE_PROJECT}
                </Button>
              )}
              {current < steps.length - 1 && (
                <Button
                  disabled={isNextDisabled(current)}
                  type="auth"
                  onClick={() => next()}
                >
                  {LOCALIZATION.NEXT}
                </Button>
              )}
            </div>
          </div>
        </Form>
        <Modal
          width={426}
          open={loadingModal}
          onCancel={handleModalCancel}
          footer={isProjectCompleted ? LoadingModalFooter : ""}
        >
          <div className="modal-Wrapper">
            {isProjectCompleted ? (
              <div>
                <Space className="onlyLoader creationModal " size="middle">
                  <p className="loadingHead">Project Created!</p>
                  <div className="successIcon">
                    {/* <CheckOutlined className="check" /> */}
                    <CheckIcon />
                  </div>
                </Space>
              </div>
            ) : (
              <div>
                <Space className="onlyLoader onlyLoad " size="middle">
                  <Spin size="large" />
                </Space>

                <p className="modalText">
                  Setting up project settings and creating roster. This may take
                  a few minutes
                </p>
              </div>
            )}
          </div>
        </Modal>
      </div>
    </>
  );
};

export default Index;
